import { PayableType } from "types/payable";

export const SET_SELECTED_PAYABLE_TYPE = "SET_SELECTED_PAYABLE_TYPE";

export const setSelectedPayableTypeDefinition = (
  selectedPayableType: PayableType
): Record<string, unknown> => ({
  type: SET_SELECTED_PAYABLE_TYPE,
  payload: selectedPayableType,
});
